import { useEffect, useState } from 'react';

const useLoginTries = () => {
  const [tries, setTries] = useState(0);

  const increaseTries = () => {
    setTries((prev) => prev + 1);
  };

  const resetTries = () => {
    setTries(0);
  };

  function persistTries(current: number) {
    localStorage.setItem('smls@loginTries', String(current))
  }

  useEffect(() => {
    persistTries(tries);
  }, [tries])

  return { tries, setTries, increaseTries, resetTries };
};

export default useLoginTries;
